import { Dispatcher } from '@Corim/architecture-backend'

export default Dispatcher(ENV_IS_PROD, true)